import React, { useState } from 'react';
import Chart from 'chart.js/auto'
import { Pie, Doughnut } from 'react-chartjs-2';
import { ResponsiveContainer } from "recharts";
import pageHint from '@images/info.svg';
import Separator from '@components/Separator';

import styles from './piechart.module.css';

const COLORS = [
    "#00BA88", // Teal
    "#669FF6", // Light Blue
    "#7381EA", // Periwinkle
    "#FF7F50", // Coral
    "#FFD476", // Light Orange
    "#A17FEF", // Purple
    "#FF3407", // Bright Red
    "#4CAF50", // Green
    "#FF9800", // Orange
    "#E91E63", // Pink
    "#2196F3", // Blue
    "#9C27B0", // Deep Purple
    "#FFC107", // Amber
    "#00BCD4", // Cyan
    "#795548", // Brown
    "#607D8B", // Blue Grey
    "#F44336", // Red
    "#3F51B5", // Indigo
    "#8BC34A", // Light Green
    "#009688"  // Teal Green
];

function PieChartWidget(props) {
    const labels = props.data.map(item => item.Name);
    const data = props.data.map(item => item.Value);

    const [pieData, setPieData] = useState({
        labels: labels,
        datasets: [{
            label: props.dataLabel,
            data: data,
            backgroundColor: COLORS,
            borderWidth: 3,
            hoverOffset: 1,
        }]
    });

    const [pieOptions, setPieOptions] = useState({
        // Remove the outer "options" wrapper
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true
                    }
                }
            ]
        },
        title: {
            display: true,
            text: 'Data Orgranized In Pie Slices',
            fontSize: 25
        },
        plugins: {  // Add plugins wrapper
            legend: {
                display: true,
                position: 'bottom',
                align: 'center',
                labels: {
                    boxWidth: 20,
                    padding: 20
                }
            }
        }
    });

    return (
        <React.Fragment>
            <div className={styles.featuredItem}>
                <span className={styles.featuredTitleHeader}>{props.headerTitle}
                    <span className="pageHint">
                        <img src={pageHint} />
                        <span className="tooltiptext">{props.toolTip}</span>
                    </span>
                </span>

                <Separator />
                <span className={styles.featuredTitle}>{props.title}</span>
                <br />
                <span className={styles.featuredSub}>{props.subTitle}</span>

                <div className={styles.featuredTextContainer}>
                    <ResponsiveContainer width="60%" aspect={1.5}>
                        {props.chartType === 'doughnut'
                            ? <div>
                                <Doughnut
                                    data={pieData}
                                    options={pieOptions} />
                            </div>
                            : <div>
                                <Pie
                                    data={pieData}
                                    options={pieOptions} />
                            </div>
                        }
                    </ResponsiveContainer>
                </div>
            </div>

        </React.Fragment>

    );
}
export default PieChartWidget